import { Component, Input } from '@angular/core';
import {
    PlatformService, LoggingService, TokenService, LocalStorageService, NotificationsService,
    StripeService, PriceService,  AccountService, SelectableTicket, User
} from '@varsity/services';
import { PopoverController, ToastController, NavParams } from 'ionic-angular';
import { UrlConstants, API_ENDPOINTS } from '@varsity/commons';
import { BaseComponent } from '@varsity/components';
import { InAppBrowser } from '@ionic-native/in-app-browser';
/**
 * Generated class for the IosWalletComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    selector: 'ios-wallet',
    templateUrl: 'ios-wallet.html'
})
export class IosWalletComponent extends BaseComponent {
    @Input() curTicket: SelectableTicket;
    redirectLink: string;
    ticketAdded: boolean = false;

    constructor(
        protected platformService: PlatformService,
        protected loggingService: LoggingService,
        protected tokenService: TokenService,
        protected localStorageService: LocalStorageService,
        protected notificationsService: NotificationsService,
        protected priceService: PriceService,
        protected popoverCtrl: PopoverController,
        protected toastCtrl: ToastController,
        protected accountService: AccountService,
        protected stripeService: StripeService,
        protected iab: InAppBrowser,
        protected navParams: NavParams
    ) {

        super(
            loggingService, tokenService, localStorageService,
            notificationsService, platformService, toastCtrl, popoverCtrl, iab,
            "IosWalletComponent"
        );

    }

    ngOnInit() {
        super.ngOnInit();
        this.redirectLink = this.getWalletRedirectLink(this.curTicket);      
    }

    setTicketWalletFlag(): void {
        this.ticketAdded = !this.ticketAdded;
        if (this.ticketAdded) {

            this.showNotification("Ticket added to wallet.", undefined, undefined, "success");
        }
    }

    getWalletRedirectLink(ticket: SelectableTicket): string {
        let walletRedirectLink;

        let linkToken = "?X-Token=" + ((this.localStorageService.get('token') !== "") ? this.localStorageService.get('token').trim() : "");
        let linkEvent = "&EventID=" + (ticket ? ticket.EventID : "");
        let linkLevel = "&S1=" + ((ticket && ticket.Level !== "") ? ticket.Level.trim() : "");
        let linkSection = "&S2=" + ((ticket && ticket.Section !== "") ? ticket.Section.trim() : "");
        let linkRow = "&S3=" + ((ticket && ticket.Row !== "") ? ticket.Row.trim() : "");
        let linkSeat = "&S4=" + ((ticket && ticket.Seat !== "") ? ticket.Seat.trim() : "");
        let linkCustomer = "";
        if (this.notificationsService.loggedInUser) {
            linkCustomer = "&CustomerID=" + this.notificationsService.loggedInUser.CustomerID;
        }
        let schoolFlag = "&SchoolFlag=" + true;
        let validationToken = "";

        if (this.navParams.get("validationToken")) {
            validationToken = "&Token=" + this.navParams.get("validationToken");
        }
        walletRedirectLink = UrlConstants.tokenBOUrl + API_ENDPOINTS.addToAppleWallet + linkToken + linkEvent + linkLevel + linkSection + linkRow + linkSeat + linkCustomer + schoolFlag + validationToken;
        
        return walletRedirectLink;
    }

    openTab(ev) {
        ev.preventDefault();
        if ((window as any).Passbook) {
            (window as any).Passbook.downloadPass(this.redirectLink,
                (pass, added) => {
                    this.loggingService.log(pass, added);
                    if (!added) {
                        this.showNotification("Pass not added", undefined, undefined, "error");
                    } else {
                        this.ticketAdded = true;
                    }
                }, (error) => {
                    this.showNotification("Pass not added, an error occured", undefined, undefined, "error");
                    this.loggingService.error(error);

                    // fallback to use the browser
                    const browser = this.iab.create(this.redirectLink, "_system");
                    this.ticketAdded = true;
                });
        } else {
            // using the browser version
            const browser = this.iab.create(this.redirectLink, "_system");
            this.ticketAdded = true;
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/ios-wallet/ios-wallet.ts